import Hint from './Hint';
export type { HintProps } from './Hint.types';

export default Hint;
